// Helper to create CSS variable reference with fallback
// Returns a CSS var() string that works in both styled-components and runtime
const cssVar = (varName: string, fallback: string): string => {
	return `var(${varName}, ${fallback})`;
};

export default {
	// Aliases for Colors.tsx compatibility (main1 = primary1)
	main1: cssVar("--main1", "#13c892"),
	main2: cssVar("--main2", "#ea5681"),
	main3: cssVar("--main3", "#ffc14a"),
	main4: cssVar("--main4", "#9376E8"),

	// Light aliases
	main1light: cssVar("--main1light", "#e5f8f3"),
	main2light: cssVar("--main2light", "#fbedf1"),
	main3light: cssVar("--main3light", "#fcf7ec"),
	main4light: cssVar("--main4light", "#F7F4FE"),

	//GREYS
	black: "#0f3e4a",
	mainBlack: "#000000",
	blackOpacity: "rgba(15, 62, 74, 0.25)",
	white: "#ffffff",
	greyDark: "#658C96",
	greyLight: "#8FA9AF",
	greyBorder: "#DDE9ED",
	darkBorder: "#2B5B67",
	error: "#eb5757",

	//BACKGROUNDS
	bgDark: "#ECF6F9",
	bgMedium: "#F1F8FA",
	bgLight: "#F9FCFD",
	bgBlack: "#184C59",
	bgBlackMedium: "#164652",
	bgBlackLight: "#1D4D59",

	border: {
		all: {
			borderWidth: 1,
			borderColor: "#DDE9ED",
		},
		top: {
			borderTopWidth: 1,
			borderTopColor: "#DDE9ED",
		},
		left: {
			borderLeftWidth: 1,
			borderLeftColor: "#DDE9ED",
		},
		right: {
			borderRightWidth: 1,
			borderRightColor: "#DDE9ED",
		},
		bottom: {
			borderBottomWidth: 1,
			borderBottomColor: "#DDE9ED",
		},
	},
	//FONTS
	headlineBold: "poppins-bold",
	headlineSemiBold: "poppins-semibold",
	headlineMedium: "poppins-medium",

	textMedium: "rubik-medium",
	textRegular: "rubik-regular",
};
